import Image from "next/image";
import { TopSellingProductCard } from "./TopSellingProductCard";
import { LatestBlogs } from "./LatestBlogs";

export function BlogRightSection({ topSellingProducts, latestArticles }) {
  return (
    <div className="flex flex-col items-center gap-12">
      <div className="w-full mb-[0.5rem] mt-[1rem] border border-grayD8 lg:hidden" />

      <Image
        src="/assets/lifestyle/blog-right.png"
        alt=""
        height={306}
        width={306}
        className="rounded-xl"
      />

      <div className="w-full space-y-8 hidden lg:block">
        <h6 className="font-semibold text-[1.125rem] text-grayD2">
          Top Selling Products
        </h6>
        <div className="flex flex-col gap-4">
          {topSellingProducts.map((product, index) => (
            <div key={index}>
              <TopSellingProductCard
                product={{
                  ...product,
                  slug: product?.product_slug,
                  variations: [],
                }}
              />
              <div className="mb-[0.5rem] mt-[1rem] border border-grayD8" />
            </div>
          ))}
        </div>
      </div>

      <LatestBlogs latestArticles={latestArticles} />
    </div>
  );
}
